var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { inline: "", model: _vm.artFrom },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "关键字：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入门店名称/电话",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.artFrom.keywords,
                          callback: function ($$v) {
                            _vm.$set(_vm.artFrom, "keywords", $$v)
                          },
                          expression: "artFrom.keywords",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.search } },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _vm.checkPermi([
                "admin:system:store:count",
                "admin:system:store:list",
              ]) && _vm.isNumber(_vm.headerCount.show)
                ? _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.onClickTab },
                      model: {
                        value: _vm.artFrom.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.artFrom, "status", $$v)
                        },
                        expression: "artFrom.status",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: {
                          label: "显示中的门店(" + _vm.headerCount.show + ")",
                          name: "1",
                        },
                      }),
                      _c("el-tab-pane", {
                        attrs: {
                          label: "隐藏中的门店(" + _vm.headerCount.hide + ")",
                          name: "0",
                        },
                      }),
                      _c("el-tab-pane", {
                        attrs: {
                          label:
                            "回收站的门店(" + _vm.headerCount.recycle + ")",
                          name: "2",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:system:store:save"],
                      expression: "['admin:system:store:save']",
                    },
                  ],
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.add },
                },
                [_vm._v("添加门店")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: { size: "small", data: _vm.tableData },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "image", label: "门店图片", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var index = ref.index
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview" },
                          [
                            _c("el-image", {
                              staticStyle: { width: "36px", height: "36px" },
                              attrs: {
                                src: row.image,
                                "preview-src-list": [row.image],
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "门店名称", "min-width": "150" },
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "门店电话", "min-width": "100" },
              }),
              _c("el-table-column", {
                attrs: { label: "库存信息", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("div", { staticClass: "stock-info" }, [
                          _c("div", [
                            _vm._v("商品种类："),
                            _c("span", { staticClass: "stock-value" }, [
                              _vm._v(_vm._s(row.productCount || 0)),
                            ]),
                            _vm._v(" 种"),
                          ]),
                          _c("div", [
                            _vm._v("总库存："),
                            _c(
                              "span",
                              { staticClass: "stock-value stock-stock" },
                              [_vm._v(_vm._s(row.totalStock || 0))]
                            ),
                          ]),
                          _c("div", [
                            _vm._v("总销售："),
                            _c(
                              "span",
                              { staticClass: "stock-value stock-sales" },
                              [_vm._v(_vm._s(row.totalSales || 0))]
                            ),
                          ]),
                          _c(
                            "a",
                            {
                              staticClass: "stock-detail-link",
                              on: {
                                click: function ($event) {
                                  return _vm.showDetail(row)
                                },
                              },
                            },
                            [_vm._v("查看明细")]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "detailedAddress",
                  label: "地址",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "dayTime",
                  label: "营业时间",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "isShow",
                  label: "是否显示",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var index = ref.index
                      return [
                        _vm.checkPermi(["admin:system:store:update:status"])
                          ? _c("el-switch", {
                              attrs: {
                                "active-value": true,
                                "inactive-value": false,
                                "active-text": "显示",
                                "inactive-text": "隐藏",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onchangeIsShow(row.id, row.isShow)
                                },
                              },
                              model: {
                                value: row.isShow,
                                callback: function ($$v) {
                                  _vm.$set(row, "isShow", $$v)
                                },
                                expression: "row.isShow",
                              },
                            })
                          : _c("span", [
                              _vm._v(_vm._s(row.isShow ? "显示" : "隐藏")),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var index = ref.index
                      return [
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:system:store:stock:update"],
                                expression:
                                  "['admin:system:store:stock:update']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.batchEditStock(row)
                              },
                            },
                          },
                          [_vm._v("批量改库存")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:system:store:info"],
                                expression: "['admin:system:store:info']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.edit(row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c("el-divider", { attrs: { direction: "vertical" } }),
                        _vm.artFrom.status === "2"
                          ? _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["admin:system:store:recovery"],
                                    expression:
                                      "['admin:system:store:recovery']",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.storeRecovery(row.id)
                                  },
                                },
                              },
                              [_vm._v("恢复")]
                            )
                          : _vm._e(),
                        _vm.artFrom.status === "2"
                          ? _c("el-divider", {
                              attrs: { direction: "vertical" },
                            })
                          : _vm._e(),
                        _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: [
                                  "admin:system:store:delete",
                                  "admin:system:store:completely:delete",
                                ],
                                expression:
                                  "['admin:system:store:delete', 'admin:system:store:completely:delete']",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                _vm.artFrom.status === "2"
                                  ? _vm.allDelete(row.id)
                                  : _vm.storeDelete(row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "mt20",
            attrs: {
              "current-page": _vm.artFrom.page,
              "page-sizes": [20, 40, 60, 100],
              "page-size": _vm.artFrom.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
              background: "",
            },
            on: {
              "size-change": _vm.sizeChange,
              "current-change": _vm.pageChange,
            },
          }),
        ],
        1
      ),
      _c("system-store", { ref: "template" }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量编辑门店库存",
            visible: _vm.stockDialogVisible,
            width: "900px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.stockDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "stockForm",
              attrs: { model: _vm.stockForm, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "门店名称" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.stockForm.storeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.stockForm, "storeName", $$v)
                      },
                      expression: "stockForm.storeName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "库存商品列表" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.showProductSelector },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v(" 选择商品 "),
                    ]
                  ),
                  _vm.stockForm.stockItems.length > 0
                    ? _c(
                        "div",
                        { staticClass: "stock-list" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                data: _vm.stockForm.stockItems,
                                border: "",
                                size: "small",
                                "max-height": "400",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "productName",
                                  label: "商品名称",
                                  "min-width": "150",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "product-cell" },
                                            [
                                              row.productImage
                                                ? _c("el-image", {
                                                    staticStyle: {
                                                      width: "40px",
                                                      height: "40px",
                                                      "margin-right": "8px",
                                                    },
                                                    attrs: {
                                                      src: row.productImage,
                                                      "preview-src-list": [
                                                        row.productImage,
                                                      ],
                                                      fit: "cover",
                                                    },
                                                  })
                                                : _vm._e(),
                                              _c("span", [
                                                _vm._v(_vm._s(row.productName)),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1127022993
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "currentStock",
                                  label: "当前库存",
                                  width: "100",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "current-stock" },
                                            [_vm._v(_vm._s(row.stock))]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3072474374
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "修改库存",
                                  width: "150",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _c("el-input-number", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              min: 0,
                                              max: 99999,
                                              size: "small",
                                              "controls-position": "right",
                                            },
                                            model: {
                                              value: row.newStock,
                                              callback: function ($$v) {
                                                _vm.$set(row, "newStock", $$v)
                                              },
                                              expression: "row.newStock",
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3460223007
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "变化",
                                  width: "100",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var row = ref.row
                                        return [
                                          _c(
                                            "span",
                                            {
                                              class:
                                                _vm.getStockChangeClass(row),
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.getStockChange(row))
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2410247088
                                ),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "操作",
                                  width: "80",
                                  align: "center",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (ref) {
                                        var $index = ref.$index
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "text",
                                                size: "small",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeProduct(
                                                    $index
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("移除")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3611107917
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "empty-stock" }, [
                        _c("i", { staticClass: "el-icon-info" }),
                        _c("span", [
                          _vm._v("暂无商品，请点击上方按钮选择商品"),
                        ]),
                      ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.stockDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.stockLoading },
                  on: { click: _vm.submitStockUpdate },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.productSelectorVisible,
            width: "1000px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.productSelectorVisible = $event
            },
          },
        },
        [
          _c("good-list", {
            ref: "goodList",
            attrs: { "handle-num": "many", checked: _vm.selectedProducts },
            on: {
              close: function ($event) {
                _vm.productSelectorVisible = false
              },
              getStoreItem: _vm.handleProductSelected,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.currentStoreName + " - 商品明细",
            visible: _vm.detailDialogVisible,
            width: "650px",
            modal: true,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.currentStockDetails,
                border: "",
                size: "mini",
                "max-height": "400",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "productImage",
                  label: "商品图",
                  width: "80",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var detail = ref.row
                      return [
                        _c("img", {
                          staticStyle: {
                            width: "50px",
                            height: "50px",
                            "object-fit": "cover",
                            "border-radius": "4px",
                          },
                          attrs: { src: detail.productImage, alt: "" },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "商品名称",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var detail = ref.row
                      return [_c("span", [_vm._v(_vm._s(detail.productName))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "price",
                  label: "售价",
                  width: "70",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "stock",
                  label: "库存",
                  width: "60",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "normalSalesCount",
                  label: "正常销售",
                  width: "80",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "giveawayCount",
                  label: "赠送",
                  width: "60",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "totalSalesCount",
                  label: "销售合计",
                  width: "80",
                  align: "center",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }